// extracted by mini-css-extract-plugin
export var measureBox = "_by-0";